import React, { useState } from "react";
import { ChevronDown, Download, FileCheck, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

const MenuItem = ({ icon: Icon, title, subtitle, onClick }) => (
  <button
    type="button"
    className="flex w-full items-start gap-2.5 rounded-md px-2.5 py-2 text-left hover:bg-gray-50"
    onClick={onClick}
  >
    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-gray-400" />
    <span>
      <span className="block text-sm font-medium text-gray-900">{title}</span>
      <span className="block text-xs text-gray-500">{subtitle}</span>
    </span>
  </button>
);

/** Export button with the launch-ready sheet and full-view options. */
const LaunchExportMenu = ({ exporting, disabled, hookCount, onExport }) => {
  const [open, setOpen] = useState(false);
  const run = (readyOnly) => {
    setOpen(false);
    onExport(readyOnly);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className="ml-auto h-9 shrink-0"
          disabled={!!exporting || disabled}
        >
          {exporting ? (
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          ) : (
            <Download className="w-4 h-4 mr-2" />
          )}
          {exporting ? "Exporting…" : "Export"}
          <ChevronDown className="w-3.5 h-3.5 ml-1.5 opacity-60" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-1">
        <MenuItem
          icon={FileCheck}
          title="Launch-ready sheet"
          subtitle="Ready ads due today or overdue"
          onClick={() => run(true)}
        />
        <MenuItem
          icon={Download}
          title="Everything in this view"
          subtitle={`All ${hookCount} row${hookCount === 1 ? "" : "s"} matching the filters above`}
          onClick={() => run(false)}
        />
      </PopoverContent>
    </Popover>
  );
};

export default LaunchExportMenu;
